import styled from 'styled-components'

export const Container = styled.div`
    border-top: #c7c7c7 1px solid;
    margin-top: 1.5rem;
    padding-top: 1.5rem;
`

export const UnicoButton = styled.div<{ isSubmitting: boolean }>`
    background-color: ${({ isSubmitting }) => (isSubmitting ? '#e0e0e0' : '#f0f3ff')};
    border-radius: 0.5rem;
    display: flex;
    opacity: ${({ isSubmitting }) => (isSubmitting ? 0.5 : 1)};
    pointer-events: ${({ isSubmitting }) => (isSubmitting ? 'none' : 'auto')};
    transition: background-color 0.2s ease, opacity 0.2s ease;

    ${({ isSubmitting }) =>
        !isSubmitting &&
        `
      &:hover {
        cursor: pointer;
        background-color: #e6e9ff;
      }
    `}
`

export const IconContainer = styled.div`
    padding: 1.5rem 0.62rem;
    display: flex;
    align-items: center;
`

export const MainContainer = styled.div`
    padding: 1.5rem 1.5rem 1.5rem 0rem;
    display: flex;
    flex-direction: column;
    flex: 1;
`

export const Title = styled.div`
    line-height: 1.5rem;
    margin-bottom: 0.5rem;
    color: #363636;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
`

export const Text = styled.div`
    line-height: 0.9975rem;
    margin-bottom: 1rem;
    color: #666;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 500;
`
export const Cta = styled.div<{ isSubmitting: boolean }>`
    line-height: 1.00625rem;
    color: ${({ isSubmitting }) => (isSubmitting ? '#777' : '#0037ff')};
    font-size: 0.875rem;
    font-style: normal;
    font-weight: 700;
    display: flex;
    align-items: center;
`

export const ContainerButton = styled.div`
    margin-top: 1.5rem;
    display: 'flex';
    flex: 1;
    align-items: center;
    justify-content: center;
`

export const Icon = styled.img``
